import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { VehicleModel } from 'src/app/models/archive/vehicle-model';
import { CityTableModalModel } from 'src/app/models/management/city-table-modal.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { VehicleService } from 'src/app/services/archive/vehicle.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-vehicle',
  templateUrl: './register-vehicle.component.html',
  styleUrls: ['./register-vehicle.component.scss'],
  standalone: false
})
export class RegisterVehicleComponent implements OnInit {

  @ViewChild('selectCity') citySelectionModalComponent?: CustomModalComponent | null = null;
  ascendantCity: boolean = true;
  branchId: number = 0;
  city: string = '';
  cityData: PagedResponseModel<CityTableModalModel> = new PagedResponseModel<CityTableModalModel>();
  columnSortCity: string | null = null;
  componentCitySelection = CustomTableSelectComponent;
  department: string = '';
  disabledForm: boolean = false;
  filtersCity: ColumnResponseModel[] = [];
  formVehicle: FormGroup = new FormGroup({});
  headersCity: ColumnResponseModel[] = [];
  inputsForSelectCityModal$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    filters: [],
    showCheckbox: true,
    showRecover: true
  });
  isOpened: string | undefined = undefined;
  limitCity: number = 10;
  listBranches: any[] = [];
  listConcepts: any[] = [];
  listStores: any[] = [];
  nameWindow: string = 'Captura Vehículos';
  output$ = new Subject<any>();
  pageCity: number = 1;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  severityState: string = 'success';
  stateVehicle: string = '';
  subscription: Subscription;
  titleState: string = '';
  url: string = 'vehicle';
  vehicleContract: VehicleModel = new VehicleModel();
  vehicleId: number = 0;

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private confirmDialogService: ConfirmDialogService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private vehicleService: VehicleService,
    private windowService: WindowService) {
    this.validateForm(new VehicleModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.vehicleId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getPermission();
    this.handleInitialState();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeCity(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeCity(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeBranch(branchId: number, resetForm: boolean) {
    this.city = '';
    this.department = '';
    this.branchId = branchId;
    await this.getAllLists(true);
    if (resetForm) {
      this.vehicleContract = new VehicleModel();
      this.vehicleContract.branchId = branchId;
      this.validateForm(this.vehicleContract);
      this.location.replaceState(`/${this.url}/register`);
    }
  }

  async changeCode(code: number) {
    if (!code || this.vehicleContract.code === code) { return; }
    const branchId = this.formVehicle.get('branchId')?.value;
    if (!branchId) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    }
    try {
      const response = await firstValueFrom(this.vehicleService.getVehicleByCodeAsync(branchId, code));
      this.vehicleId = response.vehicleId;
      this.vehicleContract = response;
      this.validateForm(this.vehicleContract);
      this.location.replaceState(`/${this.url}/register/${this.vehicleId}`);
    } catch (error) {
      console.error('Error al buscar el vehículo por código.', error);
    }
  }

  createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para crear vehículos. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.city = '';
    this.department = '';
    this.vehicleId = 0;
    this.vehicleContract = new VehicleModel();
    this.vehicleContract.branchId = this.branchId;
    this.validateForm(this.vehicleContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async changeStateVehicle() {
    const { vehicleId } = this.vehicleContract;
    if (!vehicleId || vehicleId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un vehículo.'
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `No tiene permisos para cambiar el estado del vehículo. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    try {
      const response = await firstValueFrom(this.vehicleService.setActiveVehicle(vehicleId));
      this.vehicleContract = response;
      this.validateForm(this.vehicleContract);
      const successMessage = response.active
        ? 'El vehículo fue activado exitosamente.'
        : 'El vehículo fue inactivado exitosamente.';
      this.toastHandlerService.showToast('success', successMessage);
    } catch (error) {
      console.error('Error al cambiar el estado del vehículo.', error);
    }
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para eliminar vehículos. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    if (!this.vehicleId || this.vehicleId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un vehículo.'
      );
      return;
    }
    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar el vehículo?')) {
      try {
        await firstValueFrom(this.vehicleService.deleteVehicle(this.vehicleContract.vehicleId));
        this.createNewRegister();
        this.toastHandlerService.showToast(
          'success',
          'El vehículo fue eliminado exitosamente.'
        );
      } catch (error) {
        console.error('Error al eliminar el vehículo.', error);
      }
    }
  }

  async getAllLists(reload: boolean) {
    try {
      if (reload) {
        const stores = await firstValueFrom(this.vehicleService.getAllStoresForSelectAsync(this.branchId));
        this.listStores = stores;
        return;
      }
      const [branches, stores, concepts] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.vehicleService.getAllStoresForSelectAsync(this.branchId)),
        firstValueFrom(this.vehicleService.getAllConceptsForSelectAsync()),
      ]);
      this.listBranches = branches;
      this.listStores = stores;
      this.listConcepts = concepts;
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formVehicle.get("branchId")?.value;
    const code = this.formVehicle.get("code")?.value;
    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    }
    this.handleVehicleNavigation(buttonClick, branchId, code)
  }

  async getCityDepartment(cityId: number) {
    try {
      const response: any = await firstValueFrom(this.vehicleService.getCityDepartment(cityId));
      this.city = response.city;
      this.department = response.department;
    } catch (error) {
      this.city = '';
      this.department = '';
      console.error('Error al obtener la ciudad y el departamento.', error);
    }
  }

  async getCitiesForSelection() {
    try {
      this.cityData = await firstValueFrom(
        this.vehicleService.getCitiesForSelection(
          this.pageCity, this.limitCity, this.columnSortCity, this.ascendantCity, this.filtersCity
        )
      );
      this.updateInputsForSelectCityModal();
    } catch (error) {
      console.error('Error al obtener las ciudades para el modal.', error);
    }
  }

  async getColumnsForCitiesSelection() {
    try {
      if (this.headersCity.length === 0) {
        this.headersCity = await firstValueFrom(this.vehicleService.getColumnsForCitiesSelection());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para el modal de ciudades.', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(
        this.userAuthenticatedService.branchObservable.pipe(
          filter(branch => !!branch && branch.branchId !== 0)
        )
      );
      this.branchId = response.branchId;
    } catch (error) {
      console.error('Error al obtener la primera sucursal del usuario autenticado.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getFirstBranchByUserAuthenticatedAsync();
    await Promise.all([
      this.getAllLists(false),
      this.getPermissionProfileByUrl(),
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getVehicleById() {
    try {
      const response = await firstValueFrom(this.vehicleService.getVehicleById(this.vehicleId));
      const branchChanged = this.branchId != response.branchId;
      if (branchChanged) {
        await this.changeBranch(response.branchId, false);
      }
      this.vehicleContract = response;
      this.validateForm(this.vehicleContract);
      this.location.replaceState(`/${this.url}/register/${this.vehicleId}`);
    } catch (error) {
      console.error('Error al obtener el vehículo por id.', error);
    }
  }

  async handleInitialState() {
    if (this.vehicleId !== null && this.vehicleId !== 0) {
      await this.getVehicleById();
    } else {
      this.createNewRegister();
    }
  }

  async handleVehicleNavigation(buttonClick: any, branchId: number, code: number) {
    const actionMap: Record<string, () => Promise<VehicleModel>> = {
      first: async () =>
        await firstValueFrom(this.vehicleService.getFirstVehicleByKeysAsync(branchId)),
      previus: async () =>
        await firstValueFrom(this.vehicleService.getPreviusVehicleByKeysAsync(branchId, code)),
      next: async () =>
        await firstValueFrom(this.vehicleService.getNextVehicleByKeysAsync(branchId, code)),
      last: async () =>
        await firstValueFrom(this.vehicleService.getLastVehicleByKeysAsync(branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.vehicleId = 0;
      this.vehicleContract = new VehicleModel();
      this.vehicleContract.branchId = branchId;
      return;
    }
    try {
      const vehicle = await action();
      this.vehicleId = vehicle.vehicleId;
      this.vehicleContract = vehicle;
      this.validateForm(this.vehicleContract);
      this.location.replaceState(`/${this.url}/register/${this.vehicleId}`);
    } catch (error) {
      this.vehicleContract = new VehicleModel();
      this.vehicleContract.vehicleId = 0;
      this.vehicleContract.branchId = branchId;
      this.vehicleContract.code = code;
      console.error(`Error al buscar el vehículo (${buttonClick.target.id}).`, error);
    }
  }

  async onFilterChangeCity(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersCity = this.removeDuplicates(filters);
    this.filtersCity.forEach((filter: any) => this.processFilter(filter));
    this.updateInputsForSelectCityModal();
  }

  async onPageChangeCity(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageCity = event.page;
    this.limitCity = event.pageSize;
    this.columnSortCity = event.sortField || null;
    this.ascendantCity = event.sortOrder === 1;
    this.getCitiesForSelection();
  }

  async openCitySelectionModal() {
    if (!this.vehicleContract.active) {
      this.toastHandlerService.showToast(
        'warning',
        'Para modificar la ciudad, el vehículo debe estar activo.'
      );
      return;
    }
    try {
      this.filtersCity = [];
      await Promise.all([
        this.getColumnsForCitiesSelection(),
        this.getCitiesForSelection()
      ]);
      this.updateInputsForSelectCityModal();
      this.citySelectionModalComponent?.show();
    } catch (error) {
      console.error('Error al abrir el modal de selección de ciudad.', error);
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersCity = this.filtersCity.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersCity.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send() {
    this.validateFormControls();
    if (this.formVehicle.valid) {
      const modelVehicle = this.formVehicle.getRawValue() as VehicleModel;
      if (this.vehicleId == 0) {
        try {
          const response = await firstValueFrom(this.vehicleService.createVehicle(modelVehicle));
          this.vehicleId = response.vehicleId;
          this.vehicleContract = response;
          this.validateForm(this.vehicleContract);
          this.location.replaceState(`/${this.url}/register/${this.vehicleId}`);
          this.toastHandlerService.showToast(
            'success',
            `El vehículo fue creado exitosamente.`
          );
        } catch (error) {
          console.error('Error al crear el vehículo.', error);
        }
      } else {
        this.vehicleContract.branchId = modelVehicle.branchId;
        this.vehicleContract.code = modelVehicle.code;
        this.vehicleContract.description = modelVehicle.description;
        this.vehicleContract.plate = modelVehicle.plate;
        this.vehicleContract.capacity = modelVehicle.capacity;
        this.vehicleContract.conceptId = modelVehicle.conceptId;
        this.vehicleContract.departmentId = modelVehicle.departmentId;
        this.vehicleContract.cityId = modelVehicle.cityId;
        this.vehicleContract.active = modelVehicle.active;
        this.vehicleContract.swExternal = modelVehicle.swExternal;
        this.vehicleContract.storeId = modelVehicle.storeId;
        try {
          const response = await firstValueFrom(this.vehicleService.updateVehicle(this.vehicleContract));
          this.vehicleContract = response;
          this.validateForm(this.vehicleContract);
          this.toastHandlerService.showToast(
            'success',
            `El vehículo fue modificado exitosamente.`
          );
        } catch (error) {
          console.error('Error al actualizar el vehículo.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  async setCityDepartment(selectedItems: any) {
    const [city] = selectedItems;
    this.city = `${city.cityCode} - ${city.cityName}`;
    this.department = `${city.departmentCode} - ${city.departmentName}`;
    this.formVehicle.patchValue({
      cityId: city.id,
      departmentId: city.departmentId
    });
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.'
      },
      code: {
        required: 'El campo Código es obligatorio.'
      },
      description: {
        required: 'El campo Descripción es obligatorio.',
        maxlength: 'La Descripción no puede tener más de 50 caracteres.'
      },
      plate: {
        required: 'El campo Placa es obligatorio.',
        maxlength: 'La Placa no puede tener más de 8 caracteres.'
      },
      capacity: {
        min: 'La Capacidad no puede ser menor que 0.',
        max: 'La Capacidad no puede superar 999.'
      },
      conceptId: {
        required: 'Debe seleccionar un Concepto.',
        min: 'Debe seleccionar un Concepto válido.'
      },
      departmentId: {
        required: 'Debe seleccionar un Departamento.'
      },
      cityId: {
        required: 'Debe seleccionar una Ciudad.',
        min: 'Debe seleccionar una Ciudad válida.',
      },
      storeId: {
        required: 'Debe seleccionar una Bodega.'
      },
      swExternal: {
        required: 'Debe indicar si el vehículo es externo o no.'
      },
      active: {
        required: 'Debe indicar si el vehículo está activo o inactivo.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formVehicle.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateInputsForSelectCityModal() {
    this.inputsForSelectCityModal$.next({
      headers: this.headersCity,
      data: this.cityData,
      filters: this.filtersCity,
      showCheckbox: true,
      showRecover: true
    });
  }

  updateFormState() {
    if (this.vehicleContract.active) {
      this.disabledForm = false;
      this.titleState = 'Inactivar';
      this.severityState = 'success';
      this.stateVehicle = 'Activo';
      setTimeout(() => this.formVehicle.enable());
      const controlCode = this.formVehicle.controls['code'];
      setTimeout(() => this.vehicleContract.vehicleId != 0 ?
        controlCode.enable() : controlCode.disable());
    } else {
      this.disabledForm = true;
      this.titleState = 'Activar';
      this.severityState = 'danger';
      this.stateVehicle = 'Inactivo';
      setTimeout(() => {
        this.formVehicle.disable(),
          this.formControlStateService.setControlState(this.formVehicle, ['branchId', 'code'], true);
      });
    }
    if (!this.permissionUpdatable) {
      this.disabledForm = true;
      setTimeout(() => this.formVehicle.disable());
    }
  }

  async validateForm(vehicle: VehicleModel) {
    this.formVehicle = this.formBuilder.group({
      branchId: [vehicle.branchId, [Validators.required]],
      code: [vehicle.code, [Validators.required]],
      description: [vehicle.description, [Validators.required, Validators.maxLength(50)]],
      plate: [vehicle.plate, [Validators.required, Validators.maxLength(8)]],
      capacity: [vehicle.capacity, [Validators.min(0), Validators.max(999)]],
      conceptId: [vehicle.conceptId, [Validators.required, Validators.min(1)]],
      departmentId: [vehicle.departmentId, [Validators.required]],
      cityId: [vehicle.cityId, [Validators.required, Validators.min(1)]],
      active: [vehicle.active],
      swExternal: [vehicle.swExternal],
      storeId: [vehicle.storeId, [Validators.required]]
    });
    this.updateFormState();
    if (vehicle.vehicleId > 0) {
      await this.getCityDepartment(vehicle.cityId);
    }
  }

  validateFormControls() {
    Object.keys(this.formVehicle.controls).forEach((key) => {
      const control = this.formVehicle.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
